





































import { Component, Vue, Prop } from 'vue-property-decorator'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import ConfirmationMessage from '@/components/WorkspaceSettings/ConfirmationMessage.vue'
import { Checkbox } from '@alpha/ink'
import { UserWorkspacePreference } from '@shared/types/database'
import { SettingsSubmissionData, SettingsSubmissionResponse, SettingsConfirmation } from '@/views/WorkspaceSettings.vue'

@Component({
  name: 'NotificationSettings',
  components: { AjaxButton, ConfirmationMessage, SettingsCard, Checkbox }
})
export default class NotificationSettings extends Vue {
  @Prop({ required: true }) preferences!: UserWorkspacePreference

  confirmation: SettingsConfirmation = {
    status: false,
    msg: ''
  }

  notifyOfActivity: boolean = !!(this.preferences.email_comment_notification &&
      this.preferences.email_comment_notification === 'on')

  submitting: boolean = false

  submit () {
    if (!this.submitting) {
      this.confirmation.status = false
      this.submitting = true
      const submitObj: SettingsSubmissionData = {
        component: this,
        section: 'notifications',
        data: {
          email_comment_notification: this.notifyOfActivity
            ? 'on'
            : 'off'
        }
      }
      this.$emit('submit', submitObj)
    }
  }

  finish (confirmation: SettingsSubmissionResponse) {
    const that = this
    this.confirmation = confirmation
    this.submitting = false;
    (this.$refs.saveButton as AjaxButton).finish()
    if (confirmation.status !== 'failure') {
      setTimeout(function () {
        that.$set(that.confirmation, 'status', false)
      }, 3000)
    }
  }
}
